import React from 'react';
import PropTypes from 'prop-types';
import ToggleButtons from '../ToggleButtons';
import PayManually from '../PayManually';
import Banner, { BANNER_TYPES } from '../Banner';
import { ValidationResultType, currencyToStringFactory } from '../../utils/CheckoutUtils';
import styles from './Checkout.scss';
import { CheckoutTypes } from '../../utils/constants';
import { translate } from 'react-i18next';
import _ from 'lodash';
import ArrowLeft from 'wix-ui-icons-common/ArrowLeft';

import { Card, Heading, TextButton } from 'wix-style-react';

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirmationModal: false,
    };
  }

  selectPaymentType = paymentType => {
    this.props.selectPaymentType({ paymentType });
  };

  render() {
    const {
      paymentsValue,
      paymentTypes,
      paymentMethods,
      paymentMetadata,
      allowSplitPayments,
      removePayment,
      addPayment,
      updatePayment,
      currency,
      locale,
      placeOrderResult,
      setAssociateDishPaymentIndex,
      orderItems,
      payments,
      itemsHash,
      paymentAssociations,
      checkoutType,
      setCheckoutType,
      derivedPpdData,
      displayModal,
      acceptsTip,
      t,
      offlinePayments,
      networks,
      collectionMethod,
      selectSinglePaymentMethod,
      addCashierPayment,
      setPendingPayment,
      hasPendingPayment,
    } = this.props;

    const showTabs = paymentsValue.length >= 2 && !_.isEmpty(orderItems);

    const tabsOptions = [
      {
        id: CheckoutTypes.MANUALLY,
        value: t('phoneordering_checkout_split_totalcost_tab'),
      },
      {
        id: CheckoutTypes.PAY_PER_DISH,
        value: t('phoneordering_checkout_split_perdish_tab'),
      },
    ];

    return (
      <React.Fragment>
        <TextButton
          dataHook="checkout-back-button"
          priority="secondary"
          onClick={() => this.props.backToOrder()}
          prefixIcon={<ArrowLeft />}
          className={styles.backButton}
        >
          {t('phoneordering_checkout_back_cta')}
        </TextButton>
        <Card className={styles.wrapper}>
          <div className={styles.content} data-hook="checkout-payment-wrapper">
            <Heading appearance="H2" data-hook={'checkout-payment-title'}>
              {t('phoneordering_checkout_paymentmethod_title')}
            </Heading>
            {showTabs && (
              <ToggleButtons
                data-hook="checkout-tabs-menu"
                className={styles.tabs}
                options={tabsOptions}
                value={checkoutType}
                onChange={value => setCheckoutType({ checkoutType: value })}
              />
            )}
            <PayManually
              acceptsTip={acceptsTip}
              selectPaymentType={this.selectPaymentType}
              removePayment={removePayment}
              addPayment={addPayment}
              updatePayment={updatePayment}
              paymentsValue={paymentsValue}
              paymentTypes={paymentTypes}
              paymentMethods={paymentMethods}
              paymentMetadata={paymentMetadata}
              allowSplitPayments={allowSplitPayments}
              currency={currency}
              locale={locale}
              data-hook="checkout-pay-manually"
              checkoutType={checkoutType}
              setAssociateDishPaymentIndex={setAssociateDishPaymentIndex}
              orderItems={orderItems}
              payments={payments}
              itemsHash={itemsHash}
              paymentAssociations={paymentAssociations}
              derivedPpdData={derivedPpdData}
              displayModal={displayModal}
              offlinePayments={offlinePayments}
              networks={networks}
              collectionMethod={collectionMethod}
              selectSinglePaymentMethod={selectSinglePaymentMethod}
              addCashierPayment={addCashierPayment}
              setPendingPayment={setPendingPayment}
              hasPendingPayment={hasPendingPayment}
            />
            <ErrorBanner
              className={styles.errorMessage}
              error={placeOrderResult.error}
              currency={currency}
              locale={locale}
              t={t}
            />
          </div>
        </Card>
      </React.Fragment>
    );
  }
}

Checkout.displayName = 'Checkout';
Checkout.propTypes = {
  backToOrder: PropTypes.func,
  currency: PropTypes.string,
  currencySymbol: PropTypes.string,
  locale: PropTypes.string,
  placeOrder: PropTypes.func,
  placeOrderResult: PropTypes.shape({
    error: PropTypes.object,
    orderInfo: PropTypes.object,
  }),
  setAssociateDishPaymentIndex: PropTypes.func,
  clearAssociateDishPaymentIndex: PropTypes.func,
  orderItems: PropTypes.array,
  payments: PropTypes.array,
  itemsHash: PropTypes.object,
  paymentAssociations: PropTypes.array,
  checkoutType: PropTypes.oneOf([CheckoutTypes.MANUALLY, CheckoutTypes.PAY_PER_DISH]),
  setCheckoutType: PropTypes.func,
  derivedPpdData: PropTypes.array,
  displayModal: PropTypes.func,
  hideModal: PropTypes.func,
  t: PropTypes.func,
  offlinePayments: PropTypes.bool,
  networks: PropTypes.array,
  collectionMethod: PropTypes.oneOf(['online', 'cod', 'phone']).isRequired,
  isWaitingForResponseFromServer: PropTypes.bool,
  setPendingPayment: PropTypes.func,
  hasPendingPayment: PropTypes.bool,
};
Checkout.defaultProps = {
  derivedPpdData: [],
  networks: [],
};

export default translate()(Checkout);

function ErrorBanner({ error, className, currency, locale, t }) {
  if (!error) return null;
  let errorMessage = '';
  const currencyToString = currencyToStringFactory({ currency, locale });
  if (error.type === ValidationResultType.OVER_PAY) {
    errorMessage = (
      <span data-hook="error-banner-diff">
        {t('phoneordering_checkout_split_deduct_error', {
          amount: currencyToString(error.diff),
        })}
      </span>
    );
  } else if (error.type === ValidationResultType.UNDER_PAY) {
    errorMessage = (
      <span data-hook="error-banner-diff">
        {t('phoneordering_checkout_split_add_error', {
          amount: currencyToString(error.diff),
        })}
      </span>
    );
  } else {
    errorMessage = `THIS IS THE DEFAULT ERROR MESSAGE WE NEED TO CHANGE IT
    ${error}
    `;
  }
  return (
    <Banner type={BANNER_TYPES.ERROR} className={className}>
      {errorMessage}
    </Banner>
  );
}
